import { Grid } from '@mui/material';
import { styled } from '@mui/system';

export const BorderedGrid = styled(Grid)(({ theme }) => ({
  border: `1px solid ${theme.palette.extendedGrey?.neutralLight}`,
  borderRadius: '8px',
  marginBottom: '20px',
  padding: '20px',
}));
